<div class="e-extraction-row" [class.e-extraction-row-selected]="isExpanded" tabindex="0" role="rowgroup" #extractionRow>
    <div class="e-extraction-row-core">
        <div class="e-extraction-row-title" id="extraction-{{ extraction.id }}">
            <mat-checkbox (change)="onSelect($event, extraction.id)">{{ extraction.title }}</mat-checkbox>
        </div>
        <div class="e-extraction-row-date">
            {{ extraction.dateCreated | date: 'd MMM yyyy' }}
        </div>
        <div class="e-extraction-row-status">
            {{ getStatus() }}
        </div>
        <div class="e-extraction-row-reload">
            <button class="e-load-filters-button" mat-button color="primary" (click)="navigateToFilterData()">Reload Selections</button>
        </div>
        <div class="e-extraction-row-toggle">
            <button
                (click)="toggleExtractionRow()"
                [attr.aria-expanded]="isExpanded"
                attr.aria-controls="extraction-details-{{ extraction.id }}">
                View filter selections
                <i class="far fa-chevron-down"></i>
            </button>
        </div>
        <div class="e-extraction-row-download">
            <button
                aria-label="Download extraction"
                (click)="downloadClick(extraction.id, extraction.title, extraction.fileType, extraction.includeAttributesFile)"
                [disabled]="isButtonDisabled()">
                <i class="fas fa-download"></i>
            </button>
        </div>
    </div>

    <div
        *ngIf="isExpanded"
        class="e-extraction-details"
        role="region"
        attr.aria-labelledby="extraction-{{ extraction.id }}"
        id="extraction-details-{{ extraction.id }}">
        <div class="e-extraction-info">
            <h4>Extraction date range:</h4>
            <span>
                {{ extraction.startDate | date: 'd MMM yyyy' }} -
                {{ extraction.endDate | date: 'd MMM yyyy' }}
            </span>

            <ng-container *ngIf="extraction.skuCount">
                <h4 class="e-sku-count-label">Total number of SKUs:</h4>
                <span>{{ extraction.skuCount }}</span>
            </ng-container>
            <br />

            <h4 class="e-description-label">Description:</h4>
            <p>{{ extraction.description }}</p>
        </div>
        <div class="e-extraction-filters">
            <h4>Filters summary</h4>

            <div>
                <h5>Countries</h5>
                <ng-container *ngIf="extraction.filterNames.countries.length > 0; else allCountries">
                    <span class="e-filter-name" *ngFor="let country of extraction.filterNames.countries">
                        {{ country }}
                    </span>
                </ng-container>
                <ng-template #allCountries>
                    <em>All countries applicable</em>
                </ng-template>
            </div>

            <div>
                <h5>Categories</h5>
                <ng-container *ngIf="extraction.filterNames.categories.length > 0; else allCategories">
                    <span class="e-filter-name" *ngFor="let category of extraction.filterNames.categories">
                        {{ category }}
                    </span>
                </ng-container>
                <ng-template #allCategories>
                    <em>All categories applicable</em>
                </ng-template>
            </div>

            <div>
                <h5>Suppliers</h5>
                <ng-container *ngIf="extraction.filterNames.suppliers.length > 0; else allSuppliers">
                    <span class="e-filter-name" *ngFor="let supplier of extraction.filterNames.suppliers">
                        {{ supplier }}
                    </span>
                </ng-container>
                <ng-template #allSuppliers>
                    <em>All suppliers applicable</em>
                </ng-template>
            </div>

            <div>
                <h5>Brands and Sub-brands</h5>
                <ng-container *ngIf="extraction.filterNames.brands.length > 0; else allBrands">
                    <span class="e-filter-name" *ngFor="let brand of extraction.filterNames.brands">
                        {{ brand }}
                    </span>
                </ng-container>
                <ng-template #allBrands>
                    <em>All brands and sub-brands applicable</em>
                </ng-template>
            </div>

            <div>
                <h5>Attribute Types</h5>
                <ng-container *ngIf="extraction.filterNames.attributeTypes.length > 0; else allAttributeTypes">
                    <span class="e-filter-name" *ngFor="let attributeType of extraction.filterNames.attributeTypes">
                        {{ attributeType }}
                    </span>
                </ng-container>
                <ng-template #allAttributeTypes>
                    <em>All attribute types applicable</em>
                </ng-template>
            </div>

            <div>
                <h5>Attributes</h5>
                <ng-container *ngIf="extraction.filterNames.attributes.length > 0; else allAttributes">
                    <span class="e-filter-name" *ngFor="let attribute of extraction.filterNames.attributes">
                        {{ attribute }}
                    </span>
                </ng-container>
                <ng-template #allAttributes>
                    <em>All attributes applicable</em>
                </ng-template>
            </div>

            <div>
                <h5>Retailer Types</h5>
                <ng-container *ngIf="extraction.filterNames.retailerTypes.length > 0; else allRetailerTypes">
                    <span class="e-filter-name" *ngFor="let retailerType of extraction.filterNames.retailerTypes">
                        {{ retailerType }}
                    </span>
                </ng-container>
                <ng-template #allRetailerTypes>
                    <em>All retailer types applicable</em>
                </ng-template>
            </div>

            <div>
                <h5>Retailers</h5>
                <ng-container *ngIf="extraction.filterNames.retailers.length > 0; else allRetailers">
                    <span class="e-filter-name" *ngFor="let retailer of extraction.filterNames.retailers">
                        {{ retailer }}
                    </span>
                </ng-container>
                <ng-template #allRetailers>
                    <em>All retailers applicable</em>
                </ng-template>
            </div>
            <div>
                <h5>Search Term</h5>
                <ng-container *ngIf="extraction.searchPhrase; else noSearchTerm">
                    <span class="e-filter-name">
                     {{ extraction.searchPhrase }}
                    </span>
                </ng-container>
                <ng-template #noSearchTerm>
                    <em>Search term not available</em>
                </ng-template>
            </div>

            <div>
                <h5>Date Range/Price/Total SKU Size</h5>
                <ng-container *ngIf="isTotalSKUSizeOrRangeFilterApplied(); else allRangeFilters">
                    <div>
                        <span class="e-filter-name" *ngIf="extraction.startDate && extraction.endDate">
                            {{ extraction.startDate | date: 'd MMM yyyy' }} - {{ extraction.endDate | date: 'd MMM yyyy' }}
                        </span>

                        <span class="e-filter-name" *ngIf="extraction.skuFilters.firstSeenPriceRange">
                            First seen price: {{ extraction.skuFilters.firstSeenPriceRange?.min }} - {{ extraction.skuFilters.firstSeenPriceRange?.max }}
                        </span>

                        <span class="e-filter-name" *ngIf="extraction.skuFilters.lastSeenPriceRange">
                            Last seen price: {{ extraction.skuFilters.lastSeenPriceRange?.min }} - {{ extraction.skuFilters.lastSeenPriceRange?.max }}
                        </span>

                        <span class="e-filter-name" *ngIf="extraction.skuFilters.volumeRange">
                            Volume: {{ extraction.skuFilters.volumeRange?.min }} - {{ extraction.skuFilters.volumeRange?.max }} / ml
                        </span>

                        <span class="e-filter-name" *ngIf="extraction.skuFilters.weightRange">
                            Weight: {{ extraction.skuFilters.weightRange?.min }} - {{ extraction.skuFilters.weightRange?.max }} / g
                        </span>

                        <span class="e-filter-name" *ngIf="extraction.skuFilters.countRange">
                            Count: {{ extraction.skuFilters.countRange?.min }} - {{ extraction.skuFilters.countRange?.max }}
                        </span>
                    </div>
                </ng-container>
                <ng-template #allRangeFilters>
                    <em>All Date Range / Price / Total SKU Size applicable</em>
                </ng-template>
            </div>

            <div>
                <h5>Promotions</h5>
                <ng-container *ngIf="extraction.filterNames.promotions.length > 0; else allPromotions">
                    <span class="e-filter-name" *ngFor="let promotion of extraction.filterNames.promotions">
                        {{ promotion }}
                    </span>
                </ng-container>
                <ng-template #allPromotions>
                    <em>All promotions applicable</em>
                </ng-template>
            </div>
        </div>
    </div>
</div>
